import curdGenerator from "./curdGenerator";

export const medicalStore = [
  {
    module: "Medical Store",
    children: [
      {
        module: "Masters",
        children: [
          curdGenerator("Category"),
          curdGenerator("Pharma Company"),
          curdGenerator("Medicine Composition"),
          curdGenerator("Medicine Group"),
          curdGenerator("Item")
        ]
      },
      {
        module: "Transactions",
        children: [
          curdGenerator("Purchase Bill"),
          curdGenerator("Purchase Bill Return"),
          curdGenerator("Sale Bill"),
          curdGenerator("Sale Bill Return"),
          curdGenerator("Issue Receive"),
          curdGenerator("Department Issue"),
          curdGenerator("Estimate"),
          curdGenerator("Stock Transfer")
        ]
      },
      {
        module: "Reports",
        children: [
          {
            module: "MRN Register",
            permission: "mrnregister",
            children: []
          },
          {
            module: "Purchase Register",
            permission: "purchaseregister",
            children: []
          },
          {
            module: "Purchase Summary",
            permission: "purchasesummary",
            children: []
          },
          { module: "Sale Register", permission: "salesummary", children: [] },
          {
            module: "Sale Register Restricted",
            permission: "saleregisterrestricted",
            children: []
          },
          { module: "Sale Summary", permission: "salesummary", children: [] },
          {
            module: "Issue Receive Register",
            permission: "issuereceiveregister",
            children: []
          },
          {
            module: "Stock Transfer Register",
            permission: "stocktransferregister",
            children: []
          },
          {
            module: "Estimate Register",
            permission: "estimateregister",
            children: []
          },
          {
            module: "Expiry Report",
            permission: "expiryreport",
            children: []
          },
          {
            module: "IPD Medicine Issue Report",
            permission: "ipdmedicineissuereport",
            children: []
          },
          {
            module: "IPD Medicine Issue Summary",
            permission: "ipdmedicineissuesummary",
            children: []
          },
          {
            module: "IPD Medicine Bills Reprint",
            permission: "ipdmedicinebillsreprint",
            children: []
          },
          {
            module: "Non Moving Medicine",
            permission: "nonmovingmedicine",
            children: []
          },
          {
            module: "Item Wise Profitability Report",
            permission: "itemwiseprofitabilityreport",
            children: []
          },
          {
            module: "Item Wise Purchase Sale Report",
            permission: "itemwisepurchasesalereport",
            children: []
          },
          {
            module: "Discharge Bill Report",
            permission: "dischargebillreport",
            children: []
          },
          {
            module: "Medical Activity Report",
            permission: "medicalactivityreport",
            children: []
          },
          {
            module: "MIS Report",
            permission: "misreport",
            children: []
          },
          {
            module: "User Wise Collection Register",
            permission: "userwisecollectionregister",
            children: []
          },
          {
            module: "User Wise Edit Report Purchase",
            permission: "userwiseeditreportpurchase",
            children: []
          },
          {
            module: "User Wise Edit Report Sale",
            permission: "userwiseeditreportsale",
            children: []
          },
          {
            module: "Sale Audit Report",
            permission: "saleauditreport",
            children: []
          },
          {
            module: "Department Issue Register",
            permission: "departmentissueregister",
            children: []
          }
        ]
      },
      {
        module: "Stock Reports",
        children: [
          {
            module: "Opening Stock Report",
            permission: "openingstockreport",
            children: []
          },
          {
            module: "Stock Ledger",
            permission: "stockledger",
            children: []
          },
          {
            module: "Stock Summary",
            permission: "stocksummary",
            children: []
          },
          {
            module: "Stock Taking Sheet",
            permission: "stocktakingsheet",
            children: []
          },
          {
            module: "Stock Order Report",
            permission: "stockorderreport",
            children: []
          },
          {
            module: "Stock Valuation",
            permission: "stockvaluation",
            children: []
          },
          {
            module: "Stock Report",
            permission: "stockreport",
            children: []
          },
          {
            module: "Batch Wise Stock Summary",
            permission: "batchwisestocksummary",
            children: []
          },
          {
            module: "Department Wise Stock Summary",
            permission: "departmentwisestocksummary",
            children: []
          }
        ]
      },
      {
        module: "Tax Reports",
        children: [
          {
            module: "Purchase GST Report",
            permission: "purchasegstreport",
            children: []
          },
          {
            module: "Sale GST Report",
            permission: "salegstreport",
            children: []
          },
          {
            module: "GST In Tax Report",
            permission: "gstintaxreport",
            children: []
          },
          {
            module: "GST Out Tax Report",
            permission: "gstouttaxreport",
            children: []
          },
          {
            module: "GST Computation Report",
            permission: "gstcomputationreport",
            children: []
          }
        ]
      },
      {
        module: "Utility",
        children: [
          {
            module: "Environment Setting",
            permission: "environmentsetting",
            children: []
          },
          {
            module: "Profit Slab",
            permission: "profitslab",
            children: []
          },
          {
            module: "Stock Updation",
            permission: "stockupdation",
            children: []
          },
          {
            module: "Payment Receive Posting",
            permission: "paymentreceiveposting",
            children: []
          }
        ]
      }
    ]
  }
];
